import React from "react";
import { useAccountSettings } from "@/entities/settings/hooks";
import { getCurrencySymbol } from "@/pages/deals/helpers";
import { extractKeyValuePairs } from "../../GeneralSettings";

const DEFAULT_CURRENCY_SYMBOL = "$";

export const useCurrencySymbol = (): string => {
  const accountSettingsQuery = useAccountSettings();
  const accountSettings = accountSettingsQuery.data;

  return React.useMemo(() => {
    if (accountSettings && accountSettings.length > 0) {
      const keyValuePairs = extractKeyValuePairs(accountSettings);
      const currency = keyValuePairs?.account_currency;
      return currency
        ? getCurrencySymbol(currency) || DEFAULT_CURRENCY_SYMBOL
        : DEFAULT_CURRENCY_SYMBOL;
    }
    return DEFAULT_CURRENCY_SYMBOL;
  }, [accountSettings]);
};
